import { createCrud } from '../../CRUD';
import { TInsurance } from './types';

export const insuranceBaseModel = createCrud<TInsurance>(
  'insurances',
  'Insurance',
);
